<template>
  <div class="eol-container-box">
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">
        <a-form-model-item prop="username">
          <a-input v-model="form.username" class="search-input" style="width: 120px" placeholder="请输入账号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="name">
          <a-input v-model="form.name" class="search-input" style="width: 120px" placeholder="请输入姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="mobile">
          <a-input v-model="form.mobile" class="search-input" style="width: 120px" placeholder="请输入手机号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="class_id">
          <a-select v-model="form.class_id" placeholder="请选择班级" style="width: 120px" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="" >请选择班级</a-select-option>
            <a-select-option v-for="(item, index) in classArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="teacher_name">
          <a-input v-model="form.teacher_name" style="width: 120px" class="search-input" placeholder="请输入批阅人"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="approve_status">
          <a-select v-model="form.approve_status" placeholder="请选择批阅状态" style="width: 140px" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="" >请选择批阅状态</a-select-option>
            <a-select-option v-for="(item, index) in readArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
          <a-button class="reset-btn" @click="resetForm">重置</a-button>
        </a-form-model-item>
      </a-form-model>
       <div class="right-option-box">
            <a-button class="option-btn" type="primary" @click="exportData">导出成绩</a-button>
            <a-button class="option-btn" type="primary" @click="exportAttach">导出作业附件</a-button>
          </div>
    </div>

    <div class="table-all-box">
      <a-table :columns="columns" :data-source="tableData" rowKey="id" @change="tableOnChange" :bordered="false" size="small" :pagination="false">
        <template slot="approve_name" slot-scope="text, scope">
          {{scope.approve_status == 3 ? scope.teacher_name : scope.approve_status == 2 ? '系统批阅' : ''}}
        </template>
        <template slot="status" slot-scope="status">
          <span v-if="status == 1" class="noread">待批阅</span>
          <span v-else>已批阅</span>
        </template>
        <template slot="action" slot-scope="text, scope">
          <a-button type="link" @click="routeSkip(scope)">批阅</a-button>
          <a-button type="link" @click="exportAttach(scope)">导出作业附件</a-button>
        </template>
      </a-table>

      <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />

    </div>

  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import services from '../../../assets/js/services';
export default {
  name: "activityReport",
  components: {
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        class_id: "",
        name: '',
        username: '',
        mobile: '',
        approve_status: '',
      },
      classArr: [],
      readArr: [
        { id: 1, name: '待批阅' },
        { id: 2, name: '已批阅' },
      ],
      columns: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "created_name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
        {
          title: "所属实践班级",
          dataIndex: "class_name",
        },
        {
          title: "提交时间",
          dataIndex: "work_time",
        },
        {
          title: "批阅人",
          dataIndex: "teacher_name",
          scopedSlots: { customRender: 'approve_name' },
        },
        // {
        //   title: "满分",
        //   dataIndex: "total_score",
        // },
        // {
        //   title: "成绩",
        //   dataIndex: "score",
        //   sorter: true,
        // },
        {
          title: "满分",
          dataIndex: "total_score",
          width: "70px",
        },
        {
          title: "原始成绩",
          dataIndex: "score",
          sorter: (a, b) => a.score - b.score,
          width: "120px",
        },
        {
          title: "百分制成绩",
          dataIndex: "percent_score",
          sorter: (a, b) => a.percent_score - b.percent_score,
          width: "120px",
        },
        {
          title: "批阅状态",
          dataIndex: "approve_status",
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: '200px'
        },
      ],
      task_id: 't008',
      activity_id: '',
      order: 'score', // 排序字段
      order_by: '', // 正序asc 倒叙desc
      // sortOrder : false, // 'ascend' 'descend' false
    };
  },
  computed: {
    ...mapState({
      activityInfo: (state) => state.activityStat.activityInfo,
    }),
  },
  mounted() {
    this.activity_id = this.$route.query.id
    this.getClassList()
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolActivityClasses","getSchoolTaskWorkList","getSchoolTaskExportScore","getSchoolTaskExportAttach", "getSchoolTaskDownAttach"]),
    getClassList() {
      this.getSchoolActivityClasses({activity_id: this.activity_id,page:1,size: 100 }).then((res) => {
        if (res.code == "0000" && res.data) {
          this.classArr = res.data.items;
        }
      })
    },
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        task_id: this.task_id,
        activity_id: this.activity_id, 
        class_id: this.form.class_id,
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        teacher_name: this.form.teacher_name,
        approve_status: this.form.approve_status,
        order: this.order, // 排序字段
        order_by: this.order_by, // 正序asc 倒叙desc
      };
      this.getSchoolTaskWorkList(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    //通过field 的值进行一个判断，然后在进行排序
    tableOnChange(p, f, s){
      this.order_by = 'desc' // 正序asc 倒叙desc
      //第一个排序
      if (s.field == 'score') {
        this.order_by = s.order == 'descend' ? 'desc' : s.order ==  'ascend' ? 'asc' : ''
        this.onSearch()
      }
    },
    // 导出成绩
    exportData(){
      let that = this
      if (that.tableData && that.tableData.length > 0) {
        axios({
          url: services.HOST + `/api/school/train/work/${this.task_id}/export_score`,
          params: { 
            activity_id: this.activity_id, 
            class_id: this.form.class_id,
            name: this.form.name,
            username: this.form.username,
            mobile: this.form.mobile,
            teacher_name: this.form.teacher_name,
            approve_status: this.form.approve_status,
            order: this.order, // 排序字段
            order_by: this.order_by, // 正序asc 倒叙desc
          },
          method: 'get',
          responseType: 'arraybuffer',
        }).then(res => {
          if (res) {
            let newUrl = window.URL.createObjectURL(new Blob([res.data]));
            let type = 'xlsx'
            that.createUrlBlob(newUrl, `【${(this.activityInfo && this.activityInfo.name) || ''}】【绘云馆图谱实践成绩】`, type)
          }
        })
      } else {
        that.$message.error("暂无可导出的数据")
      }
    },
    // 文件流处理
    createUrlBlob (url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 导出作业附件
    exportAttach(obj){
      let that = this
      let params = {
        task_id: this.task_id,
        activity_id: this.activity_id, 
        class_id: this.form.class_id,
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        teacher_name: this.form.teacher_name,
        approve_status: this.form.approve_status,
      };
      if(obj){
        params.work_id = obj.id
      }
      that.getSchoolTaskExportAttach(params).then((res) => {
        if (res.code == "0000" && res.data) {
          console.log(res.data)
          if(res.data.unique){
            const targetRoute = this.$router.resolve({
              path: `/${that.school_code}/school/activity/download`,
              query: {
                id: that.activity_id,
                tid: that.task_id,
                unique: res.data.unique,
                url: 'draw'
              }
            });
            window.open(targetRoute.href, '_blank');
          }
        } else {
          that.$message.error(res.msg)
        }
      });
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    routeSkip (rows) {
      this.$router.push(`/${this.school_code}/school/activity/report/mark?id=${this.activity_id}&work_id=${rows.id}`)
    },
  },
};
</script>

<style lang="less" scoped>
.noread {
  width: 66px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  background: #F7F0E6;
  border-radius: 12px;
  color: #7B5127;
  display: inline-block;
}
.right-option-box {
  padding-top: 0;
}
</style>
